<template>
  <div></div>
</template>

<script>
import { userInfo } from '@/api/user.js'
import { setItem } from '@/utils/storage.js'
export default {
  name: 'auth',
  components: {},
  props: {},
  data() {
    return {
      userInfo: {}
    }
  },
  computed: {},
  watch: {},
  created() {
    this.getUserInfo()
  },
  mounted() {

  },
  methods: {
    async getUserInfo() {
      let res = await userInfo()
      if (res.success) {
        this.userInfo = res.data || {user: 'loginSuccess'}
        setItem('userInfo',this.userInfo)
        this.$router.replace('/home')
      }
    }
  }
}
</script>

<style scoped lang="scss">
</style>
